import { css } from '@inter-ikea-kompis/web-component';
import type { ITheme } from '@inter-ikea-kompis/types';

export default class AddToBagStyle {
	public static getStyle(options: { theme: ITheme }): string {
		const { spacing } = options.theme;

		return css`
			.divider {
				width: ${spacing.space50 / 16}rem;
				flex-shrink: 0;
			}

			.buyOnlineUnavailableIcon {
				display: block;
			}

			.buttonContainer {
				display: flex;
				justify-content: flex-end;
			}

			.shoppingCartUnavailableMessage {
				margin-bottom: ${spacing.space200 / 16}rem;
			}
		`;
	}
}
